import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { role } from 'auth-types';

interface LOGIN_STATE_TYPE {
  status: boolean;
  role: role;
  first_name: string;
  last_name: string;
  email: string;
}

const INITIAL_STATE: LOGIN_STATE_TYPE = {
  status: false,
  role: '',
  first_name: 'Student',
  last_name: '',
  email: '',
};

const loginSlice = createSlice({
  name: 'login',
  initialState: INITIAL_STATE,
  reducers: {
    setisLoggedIn(state: LOGIN_STATE_TYPE, action: PayloadAction<boolean>) {
      state.status = action.payload;
    },
    setRole(state: LOGIN_STATE_TYPE, action: PayloadAction<role>) {
      state.role = action.payload;
    },
    setUserFirstName(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.first_name = action.payload;
    },
    setUserLastName(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.last_name = action.payload;
    },
    setUserEmail(state: LOGIN_STATE_TYPE, action: PayloadAction<string>) {
      state.email = action.payload;
    },
  },
});

export const { setisLoggedIn, setRole, setUserFirstName, setUserLastName, setUserEmail } =
  loginSlice.actions;

export default loginSlice.reducer;
